<template>
	<div class="flow-header">
		<slot />
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "Header"
});
</script>
<style lang="scss">
div.flow-header {
	flex-shrink: 0;
	overflow: visible;
	display: flex;
	align-items: center;
	gap: 12px;
	grid-gap: 12px;
	height: 48px;
	// flex-grow: 1;
	padding: 0px 16px 0px 16px;

	> div.icon-container:last-child {
		margin-left: auto;
	}

	.flow-text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
</style>
